module.exports = __webpack_public_path__ + "img/stripe@2x.1bb3be30.png";